import handleCharacterEncoding from '../../handleCharacterEncoding';

/* Untertitel wird beschränkt. Sollte der Text zu lange sein, werden am Ende ...
hinzugefügt. Sollte der Untertitel zu kurz sein, wird die Beschreibung geladen (falls besser)
Funktion nimmt als Argumente die Daten an sich und die gewünschte maximale Länge */
export default function limitSubtitle(projectData, maximumNumberOfCharacters) {
  const data = projectData[0 % projectData.length];
  let ausgabeUntertitel = '';
  const untertitel = `${data.untertitel}`;

  if (untertitel.length < 100) {
    const beschreibung = `${data.beschreibung}`;
    if (beschreibung.length > untertitel.length) {
      if (beschreibung.length > maximumNumberOfCharacters) {
        const beschreibungKurz = beschreibung
          .substring(0, maximumNumberOfCharacters)
          .split(' ');
        let getrimmteBeschreibung = ' ';

        for (let i = 0; i < beschreibungKurz.length - 1; i += 1) {
          if (i === beschreibungKurz.length - 2) {
            getrimmteBeschreibung += beschreibungKurz[i];
          } else {
            getrimmteBeschreibung += `${beschreibungKurz[i]} `;
          }
        }
        ausgabeUntertitel = `${getrimmteBeschreibung}...`;
      } else {
        ausgabeUntertitel = beschreibung;
      }
    } else {
      ausgabeUntertitel = untertitel;
    }
  } else {
    // Wenn Untertitel zu lang, dann nach 300 Zeichen ... hinzufügen
    // eslint-disable-next-line no-lonely-if
    if (untertitel.length > maximumNumberOfCharacters) {
      ausgabeUntertitel = untertitel.substring(0, maximumNumberOfCharacters);

      const untertitelKurz = ausgabeUntertitel.split(' ');
      let bearbeiteterUntertitel = '';

      for (let i = 0; i < untertitelKurz.length - 1; i += 1) {
        if (i === untertitelKurz.length - 2) {
          bearbeiteterUntertitel += untertitelKurz[i];
        } else {
          bearbeiteterUntertitel += `${untertitelKurz[i]} `;
        }
      }
      ausgabeUntertitel = `${bearbeiteterUntertitel}...`;
    } else {
      ausgabeUntertitel = untertitel;
    }
  }
  return handleCharacterEncoding(ausgabeUntertitel);
}
